<div class="iframe-content">
  @if (!iframe?.url) {
    <local-loader></local-loader>
  } @else {
    <iframe *ngIf="iframe?.url" [src]="iframe?.url! | iframeURL | bypassSecurityTrustResourceUrl" frameborder="0"></iframe>
  }
</div>
